import { combineReducers } from 'redux';

import auth from './auth/reducer';
import global from './global/reducer';
import dialog from './dialog/reducer';

export default combineReducers({
  auth,
  global,
  dialog,
});
